<template>
  <div class="judge-record">
    <div class="head">
      <p @click="returnList"><i class="icon-return"></i>返回</p>
    </div>
    <div class="main-content">
      <div class="content-wrap">
        <div class="search-wrap">
          <p class="select">
            <span>试题题号</span>
            <el-select v-model="number" placeholder="请选择试题题号" @change="getRecordData(1)">
              <el-option label="全部" value="all"></el-option>
              <el-option
                v-for="item in quesList"
                :key="item.id"
                :label="`${item.name}题`"
                :value="item.id"></el-option>
            </el-select>
          </p>
          <p class="select">
            <span>备注</span>
            <el-select v-model="markStatus" placeholder="请选择" @change="getRecordData(1)">
              <el-option label="全部" value="all"></el-option>
              <el-option label="有备注" :value="1"></el-option>
              <el-option label="无备注" :value="0"></el-option>
            </el-select>
          </p>
        </div>
        <div class="table-wrap">
          <el-table
            :data="recordData"
            class="record-table"
            stripe
            header-row-class-name="record-header"
            cell-class-name="text-center"
            header-cell-class-name="text-center"
            style="width: 100%"
            height="570"
            @sort-change="sortChange"
          >
            <el-table-column
              label="题号"
              fixed
            >
              <template slot-scope="s">
                <strong>{{ s.row.questionNo }}题</strong>
              </template>
            </el-table-column>
            <el-table-column v-if="mode === 'examinee'" label="考生ID" prop="userId"></el-table-column>
            <el-table-column
              label="评分时间">
              <template slot-scope="s">
                {{ s.row.judgeTime | date('Y-m-d H:i') }}
              </template>
            </el-table-column>
            <el-table-column
              label="得分/总分"
              prop="score"
              sortable="custom"
            >
              <template slot-scope="s">
                <strong>{{ s.row.score }} / {{ s.row.totalScore }}</strong>
              </template>
            </el-table-column>
            <el-table-column
              label="备注"
              prop="note"
            >
              <template slot-scope="s">
                <el-popover
                  placement="bottom"
                  title=""
                  width="240"
                  trigger="hover"
                  :content="s.row.note">
                  <p slot="reference" class="text-split">{{ s.row.note }}</p>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
            >
              <template slot-scope="s">
                <button class="btn" @click="openDetail(s.row)">查看</button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            :current-page.sync="page"
            :page-sizes="[10, 30, 50, 100, 300, 500]"
            :page-size="limit"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            v-if="total > 0" >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Table, TableColumn, Pagination, Popover } from 'element-ui'
import { get } from '@/utils/ajax'
export default {
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElPagination: Pagination,
    ElPopover: Popover
  },
  data() {
    return {
      number: 'all',
      quesList: [],
      recordData: [],
      page: 1,
      limit: 10,
      total: 0,
      markStatus: 'all',
      scoreStatus: '',
      markingId: null,
      judgeId: null,
      judgeName: '',
      mode: ''
    }
  },
  mounted() {
    const { id, name, judgeId, mode } = this.$route.query
    this.markingId = id
    this.judgeId = judgeId
    this.judgeName = name
    this.mode = mode
    this.page = Number(localStorage.getItem('recordPage')) || 1
    this.getRecordData()
    this.getProgress()
  },
  methods: {
    // 获取阅卷记录
    async getRecordData(page) {
      this.page = page || this.page
      const params = {
        judgeId: this.judgeId,
        markingId: this.markingId,
        page: this.page,
        limit: this.limit,
        questionNo: this.number === 'all' ? '' : this.number,
        note: this.markStatus === 'all' ? '' : this.markStatus,
        score: this.scoreStatus
      }
      const { items, total } = await get(`/home/judges/history`, params)
      this.recordData = items
      this.total = total
    },
    returnList() {
      localStorage.setItem('recordPage', this.page)
      this.$router.back()
    },
    openDetail(item) {
      const routeName = this.mode === 'examinee' ? 'judgeExaminee' : 'judgeList'
      this.$router.push({ name: routeName, query: { id: this.markingId, name: this.judgeName, judgeId: this.judgeId, examineeUserId: item.userId, recordId: item.markingBasketId } })
    },
    // 分页
    handlePageChange(page) {
      this.page = page
      localStorage.setItem('recordPage', page)
      this.getRecordData()
    },
    // 处理分页-每页展示个数变化请求
    handleSizeChange(val) {
      this.limit = val
      this.getRecordData()
    },
    // 得分排序
    sortChange({ column, prop, order }) {
      switch (order) {
        case 'ascending': // 升序
          this.scoreStatus = 'asc'
          break
        case 'descending': // 降序
          this.scoreStatus = 'desc'
          break
        default:
          this.scoreStatus = ''
          break
      }
      this.getRecordData(1)
    },
    // 获取所有题号
    async getProgress() {
      const { party } = await get(`/home/judges/${this.judgeId}/progress`)
      this.quesList = []
      party.forEach(item => {
        const ques = {
          id: item.question_no,
          name: item.question_no
        }
        this.quesList.push(ques)
      })
    }
  }
}
</script>

<style>
  @import "~@/assets/styles/element.scss";
</style>
<style lang="scss" scoped>
  .head {
    width: 100%;
    height: 64px;
    line-height: 64px;
    padding: 0 60px;
    background-color: $themeColor;
    p {
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .icon-return {
    display: inline-block;
    width: 10px;
    height: 16px;
    background: url("~@/assets/images/judge/icon-return.png") center / cover no-repeat;
    margin-right: 10px;
    vertical-align: -2px;
  }
  .main-content {
    height: calc(100% - 64px);
    background-color: #FAFAFA;
    padding-top: 52px;
  }
  .content-wrap {
    width: 1400px;
    background-color: #fff;
    margin: 0 auto;
    padding: 30px 100px 60px 100px;
  }
  .search-wrap {
    display: flex;
    margin-bottom: 16px;
    /deep/ .el-input__inner {
      width: 120px;
      height: 32px;
    }
    /deep/ .el-select .el-input .el-select__caret {
      line-height: 32px;
    }
    /deep/ .el-input__icon {
      line-height: 32px !important;
    }
    .select {
      &:first-child {
        margin-right: 40px;
      }
      span {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
        font-weight: 500;
      }
    }
  }
  .btn {
    background: none;
    color: $themeColor;
    cursor: pointer;
  }
  /deep/ .record-table {
    border: 1px solid rgba(57,126,253,0.15);
    border-radius: 4px;
    .el-table__body tr.el-table__row--striped td {
      background: rgba(57,126,253,0.05);
    }
    td, th.is-leaf {
      border-bottom: 0;
    }
    td, tr {
      height: 52px;
      color: #444;
      font-size: 14px;
    }
  }
  /deep/ .record-header {
    background: $themeColor;
    border-radius: 4px 4px 0 0;
    th {
      background: none;
    }
    th>.cell {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
    }
  }
  /deep/ .text-center {
    text-align: center;
  }
  .pagination {
    text-align: right;
    padding-top: 24px;
  }
  .judge-record {
    min-width: 1400px;
    height: 100%;
  }
  .text-split {
    @include text-ellipsis(1);
    cursor: pointer;
  }
  /deep/ .el-table {
    .descending .sort-caret.descending {
      border-top-color: #fff;
    }
    .ascending .sort-caret.ascending {
      border-bottom-color: #fff;
    }
    .sort-caret.descending {
      border-top-color: rgba(255, 255, 255, .4);
    }
    .sort-caret.ascending {
      border-bottom-color: rgba(255, 255, 255, .4);
    }
  }
</style>
